export default function SimpleTest() {
  console.log('SimpleTest component rendered');
  
  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f0f0' }}>
      <h1>Simple Test Component</h1>
      <p>If you can see this, React is working!</p>
      <p>Current URL: {window.location.href}</p>
    </div>
  );
}
